import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import "./Gallery.scss";

import Gallery1 from "../../assets/images/IMG-20240312-WA0005.jpg";
import Gallery2 from "../../assets/images/IMG-20240312-WA0006.jpg";
import Gallery3 from "../../assets/images/IMG-20240312-WA0007.jpg";
import Gallery4 from "../../assets/images/IMG-20240312-WA0008.jpg";
import Gallery5 from "../../assets/images/IMG-20240312-WA0010.jpg";
import Gallery6 from "../../assets/images/IMG-20240312-WA0011.jpg";
import Gallery7 from "../../assets/images/IMG-20240312-WA0012.jpg";
import Gallery8 from "../../assets/images/IMG-20240318-WA0028.jpg";
import Gallery9 from "../../assets/images/IMG-20240312-WA0014.jpg";
import Gallery10 from "../../assets/images/IMG-20240312-WA0015.jpg";
import Gallery11 from "../../assets/images/IMG-20240312-WA0016.jpg";
import Gallery12 from "../../assets/images/IMG-20240312-WA0017.jpg";
import Gallery13 from "../../assets/images/IMG-20240312-WA0018.jpg";
import Gallery14 from "../../assets/images/IMG-20240312-WA0019.jpg";
import Gallery15 from "../../assets/images/IMG-20240312-WA0020.jpg";
import Gallery16 from "../../assets/images/IMG-20240318-WA0025.jpg";
import Gallery17 from "../../assets/images/IMG-20240318-WA0027.jpg";
import Gallery18 from "../../assets/images/IMG-20240318-WA0029.jpg";
import Gallery21 from "../../assets/images/IMG-20240318-WA0032.jpg";
import Gallery22 from "../../assets/images/IMG-20240318-WA0033.jpg";
import Gallery25 from "../../assets/images/IMG-20240318-WA0037.jpg";
import Gallery26 from "../../assets/images/Gallery26.jpg";
import Gallery27 from "../../assets/images/Gallery27.jpg";
import Gallery28 from "../../assets/images/Gallery28.jpg";
import Gallery29 from "../../assets/images/Gallery29.jpg";
import Gallery30 from "../../assets/images/Gallery30.jpg";
import Gallery31 from "../../assets/images/Gallery31.jpg";
import Gallery32 from "../../assets/images/Gallery32.jpg";
import Gallery33 from "../../assets/images/Gallery33.jpg";
import Gallery34 from "../../assets/images/Gallery34.jpg";
import Gallery35 from "../../assets/images/Gallery35.jpg";
import Gallery36 from "../../assets/images/Gallery36.jpg";
import Gallery37 from "../../assets/images/Gallery37.jpg";
import Gallery38 from "../../assets/images/Gallery38.jpg";
import Gallery39 from "../../assets/images/Gallery39.jpg";
import Gallery40 from "../../assets/images/Gallery40.jpg";

// New photos extracted from the ASKGhana funding proposal live in assets/images/GalleryImages (image_03 - image_77).
// image_01 (logo) and image_02 (cover) are intentionally left out.
import Photo03 from "../../assets/images/GalleryImages/image_03.jpg";
import Photo04 from "../../assets/images/GalleryImages/image_04.jpg";
import Photo05 from "../../assets/images/GalleryImages/image_05.jpg";
import Photo06 from "../../assets/images/GalleryImages/image_06.jpg";
import Photo07 from "../../assets/images/GalleryImages/image_07.jpg";
import Photo08 from "../../assets/images/GalleryImages/image_08.jpg";
import Photo09 from "../../assets/images/GalleryImages/image_09.jpg";
import Photo10 from "../../assets/images/GalleryImages/image_10.jpg";
import Photo11 from "../../assets/images/GalleryImages/image_11.jpg";
import Photo12 from "../../assets/images/GalleryImages/image_12.jpg";
import Photo13 from "../../assets/images/GalleryImages/image_13.jpg";
import Photo14 from "../../assets/images/GalleryImages/image_14.jpg";
import Photo15 from "../../assets/images/GalleryImages/image_15.jpg";
import Photo16 from "../../assets/images/GalleryImages/image_16.jpg";
import Photo17 from "../../assets/images/GalleryImages/image_17.jpg";
import Photo18 from "../../assets/images/GalleryImages/image_18.jpg";
import Photo19 from "../../assets/images/GalleryImages/image_19.jpg";
import Photo20 from "../../assets/images/GalleryImages/image_20.jpg";
import Photo21 from "../../assets/images/GalleryImages/image_21.jpg";
import Photo22 from "../../assets/images/GalleryImages/image_22.jpg";
import Photo23 from "../../assets/images/GalleryImages/image_23.jpg";
import Photo24 from "../../assets/images/GalleryImages/image_24.jpg";
import Photo25 from "../../assets/images/GalleryImages/image_25.jpg";
import Photo26 from "../../assets/images/GalleryImages/image_26.jpg";
import Photo27 from "../../assets/images/GalleryImages/image_27.jpg";
import Photo28 from "../../assets/images/GalleryImages/image_28.jpg";
import Photo29 from "../../assets/images/GalleryImages/image_29.jpg";
import Photo30 from "../../assets/images/GalleryImages/image_30.jpg";
import Photo31 from "../../assets/images/GalleryImages/image_31.jpg";
import Photo32 from "../../assets/images/GalleryImages/image_32.jpg";
import Photo33 from "../../assets/images/GalleryImages/image_33.jpg";
import Photo34 from "../../assets/images/GalleryImages/image_34.jpg";
import Photo35 from "../../assets/images/GalleryImages/image_35.jpg";
import Photo36 from "../../assets/images/GalleryImages/image_36.jpg";
import Photo37 from "../../assets/images/GalleryImages/image_37.jpg";
import Photo38 from "../../assets/images/GalleryImages/image_38.jpg";
import Photo39 from "../../assets/images/GalleryImages/image_39.jpg";
import Photo40 from "../../assets/images/GalleryImages/image_40.jpg";
import Photo41 from "../../assets/images/GalleryImages/image_41.jpg";
import Photo42 from "../../assets/images/GalleryImages/image_42.jpg";
import Photo43 from "../../assets/images/GalleryImages/image_43.jpg";
import Photo44 from "../../assets/images/GalleryImages/image_44.jpg";
import Photo45 from "../../assets/images/GalleryImages/image_45.jpg";
import Photo46 from "../../assets/images/GalleryImages/image_46.jpg";
import Photo47 from "../../assets/images/GalleryImages/image_47.jpg";
import Photo48 from "../../assets/images/GalleryImages/image_48.jpg";
import Photo49 from "../../assets/images/GalleryImages/image_49.jpg";
import Photo50 from "../../assets/images/GalleryImages/image_50.jpg";
import Photo51 from "../../assets/images/GalleryImages/image_51.jpg";
import Photo52 from "../../assets/images/GalleryImages/image_52.jpg";
import Photo53 from "../../assets/images/GalleryImages/image_53.jpg";
import Photo54 from "../../assets/images/GalleryImages/image_54.jpg";
import Photo55 from "../../assets/images/GalleryImages/image_55.jpg";
import Photo56 from "../../assets/images/GalleryImages/image_56.jpg";
import Photo57 from "../../assets/images/GalleryImages/image_57.jpg";
import Photo58 from "../../assets/images/GalleryImages/image_58.jpg";
import Photo59 from "../../assets/images/GalleryImages/image_59.jpg";
import Photo60 from "../../assets/images/GalleryImages/image_60.jpg";
import Photo61 from "../../assets/images/GalleryImages/image_61.jpg";
import Photo62 from "../../assets/images/GalleryImages/image_62.jpg";
import Photo63 from "../../assets/images/GalleryImages/image_63.jpg";
import Photo64 from "../../assets/images/GalleryImages/image_64.jpg";
import Photo65 from "../../assets/images/GalleryImages/image_65.jpg";
import Photo66 from "../../assets/images/GalleryImages/image_66.jpg";
import Photo67 from "../../assets/images/GalleryImages/image_67.jpg";
import Photo68 from "../../assets/images/GalleryImages/image_68.jpg";
import Photo69 from "../../assets/images/GalleryImages/image_69.jpg";
import Photo70 from "../../assets/images/GalleryImages/image_70.jpg";
import Photo71 from "../../assets/images/GalleryImages/image_71.jpg";
import Photo72 from "../../assets/images/GalleryImages/image_72.jpg";
import Photo73 from "../../assets/images/GalleryImages/image_73.jpg";
import Photo74 from "../../assets/images/GalleryImages/image_74.jpg";
import Photo75 from "../../assets/images/GalleryImages/image_75.jpg";
import Photo76 from "../../assets/images/GalleryImages/image_76.jpg";
import Photo77 from "../../assets/images/GalleryImages/image_77.jpg";

// To add a new photo: import it above, then add it to the right array.

const images = [
  Gallery30, Gallery1, Gallery2, Gallery3, Gallery16, Gallery5,
  Gallery6, Gallery4, Gallery7, Gallery8, Gallery9, Gallery10,
  Gallery11, Gallery21, Gallery22, Gallery12, Gallery13, Gallery14,
  Gallery15, Gallery17, Gallery18, Gallery25, Gallery26, Gallery27,
  Gallery28, Gallery29, Gallery31, Gallery32, Gallery33, Gallery34,
  Gallery35, Gallery36, Gallery37, Gallery38, Gallery39, Gallery40,
  Photo03, Photo04, Photo05, Photo06, Photo07, Photo08,
  Photo09, Photo10, Photo11, Photo12, Photo13, Photo14,
  Photo15, Photo16, Photo17, Photo18, Photo19, Photo20,
  Photo21, Photo22, Photo23, Photo24, Photo25, Photo26,
  Photo27, Photo28, Photo29, Photo30, Photo31, Photo32,
  Photo33, Photo34, Photo35, Photo36, Photo37, Photo38,
  Photo39, Photo40, Photo41, Photo42, Photo43, Photo44,
  Photo45, Photo46, Photo47, Photo48, Photo49, Photo50,
  Photo51, Photo52, Photo53, Photo54, Photo55, Photo56,
  Photo57, Photo58, Photo59, Photo60, Photo61, Photo62,
  Photo63, Photo64, Photo65, Photo66, Photo67, Photo68,
  Photo69, Photo70, Photo71, Photo72, Photo73, Photo74,
  Photo75, Photo76, Photo77,
];

function Gallery() {
  return (
    <>
      <Navbar />

      <div className="galleryGrid">
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`ASK Ghana outreach activity ${i + 1}`}
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>

      <Footer />
    </>
  );
}

export default Gallery;